import { FC } from 'react'
import { DesktopHeaderContainer, HeaderButtonsContainer } from './styles'
import { Text } from 'entities/Text'
import { BranchList } from 'widgets/BranchSelector'
import { DefaultBranchId } from 'widgets/DefaultBranchIdSelector'

export const DesktopHeader: FC<IDesktopHeader> = ({ pageName }) => {
  return (
    <DesktopHeaderContainer>
      <Text variant='h4' sx={{ color: 'text.primary' }}>
        {pageName || ''}
      </Text>
      <HeaderButtonsContainer>
        <DefaultBranchId />
        <BranchList />
      </HeaderButtonsContainer>
    </DesktopHeaderContainer>
  )
}

interface IDesktopHeader {
  pageName?: string
}
